import {
  useEffect,
  useState,
  useRef,
  useMemo
} from 'react';
import dayjs, {
  Dayjs
} from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const useCountdown = (date: Dayjs | string) => {
  const [timeArray, setTimeArray] = useState<Maybe<Array<number>>>(null);
  const intervalRef = useRef<Nullable<NodeJS.Timeout>>(null);

  const dateString = useMemo(() => {
    return typeof date === 'string' ? date : date?.toISOString();
  }, [date]);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setTimeArray(null);

    const calculateTimeStamp = () => {
      const now = dayjs();
      const tournamentDate = dayjs.utc(dateString);

      if (now.isAfter(tournamentDate)) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        setTimeArray(null);
        return;
      }

      const newArray: Array<number> = [];
      newArray.push(tournamentDate.diff(now, 'days'));
      newArray.push(tournamentDate.diff(now, 'hours') % 24);
      newArray.push(tournamentDate.diff(now, 'minute') % 60);
      newArray.push(tournamentDate.diff(now, 'second') % 60);

      setTimeArray(newArray);
    };

    intervalRef.current = setInterval(calculateTimeStamp, 1000);
    calculateTimeStamp();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [dateString]);

  return timeArray;
};